// extracted by mini-css-extract-plugin
export default {"container":"CE-z","title":"DE-z","link":"EE-z"};